module.exports = __webpack_public_path__ + "img/header-weddingRingsCertificate@2x.c5cfda7.webp";